<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options"
            :multiple="multiple"
            :placeholder="$t('home.selectedGroupNameText')"
            @search="getOptionsDebounce"
            :filterable="false"
            :value="$store.state.dashboard.queryFilter.groupNames"
            @input="updateValue"
            :disabled="$store.state.queryGroupName !== 'all'"
        )
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce } from "@/libs/utils";
export default {
    name: "GroupNameSelector",
    components: {},
    props: {
        multiple: { type: Boolean, default: true },
    },
    watch: {},
    data() {
        return {
            options: [],
        };
    },
    computed: {},
    methods: {
        getOptions() {
            getFormOptions(`groupnames`).then((res) => {
                this.options = res.data.options;
            });
        },
        updateValue(value) {
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "groupNames", value: value });
            this.$emit("updateGroupValue", value);
        },
    },
    mounted() {
        if (this.$store.state.queryGroupName !== "all") {
            // console.log(`GroupNameSelector detect store has queryGroupName: ${this.$store.state.queryGroupName}`);
            this.updateValue(this.$store.state.queryGroupName);
        } else {
            this.getOptions();
        }
    },
    created() {
        var self = this;
        this.getOptionsDebounce = _debounce(function (queryValue, loading) {
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`groupnames?&groupNames=*${queryValue}*`).then((res) => {
                self.options = res.data.options;
                loading(false);
            });
        });
    },
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/GroupNameSelector.vue